import React, { useEffect } from "react";
import einvData from "../assests/JSON/CloudareForEinv.json";
import "../styles/CloudareForEinv.css";
import Navigation from "../components/Navbar";
import Footer from "../components/Footer";
import Seo from "../components/Seo";

const CloudareForEInv = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top on page load
  }, []);

  return (
    <section>
        <Seo path="/cloudare-for-einvoicing" />
      <Navigation />
      <div className="cloudare-einv-container">
        {/* Heading */}
        <h2>{einvData.heading}</h2>
        <p className="cloudare-intro">{einvData.intro}</p>

        {/* Sections → rendered as bullet points like ImpactOfEinv */}
        <ul className="cloudare-list">
          {einvData.sections.map((section, index) => (
            <li key={index}>
              <strong>{section.title}:</strong> {section.description}
            </li>
          ))}
        </ul>

        {/* CTA Section */}
        <div className="cloudare-cta">
          <h3>{einvData.cta.heading}</h3>
          <p>{einvData.cta.description}</p>
          <button
            onClick={() =>
              window.open("https://calendly.com/cloudare", "_blank")
            }
          >
            {einvData.cta.buttonText}
          </button>
        </div>
      </div>

      {/* Bottom Image */}
      {einvData.image && (
        <div className="cloudare-bottomImageWrapper">
          <img
            src={require(`../assests/images/${einvData.image}`)}
            alt="Cloudare E-Invoicing"
            className="cloudare-bottom-image"
          />
        </div>
      )}
      <Footer />
    </section>
  );
};

export default CloudareForEInv;
